import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { VrsRedirectTarget } from 'features/app/store/app/enums/vrsRedirectTarget';
import type { AppState } from 'features/app/store/app/interfaces/appState';
import type { InCenterTeamingNoticeSnapshot } from 'features/app/store/app/interfaces/inCenterTeamingNoticeSnapshot';

export const initialAppState: AppState = {
  isInnerLoading: false,
  isRnsConnectionSuccess: false,
  isUnloading: false,
  isRnsConnectionClosed: false,
  isTokenSetOnHeaders: false,
  isCognitoForcedLogoutRequested: false,
  pendingVrsRedirect: null,
};

export const appSlice = createSlice({
  name: 'app',
  initialState: initialAppState,
  reducers: {
    setInnerLoading: (state, action: PayloadAction<boolean>) => {
      state.isInnerLoading = action.payload;
    },
    rnsAttemptingToReconnect: (state) => {
      state.isRnsConnectionSuccess = false;
    },
    rnsConnectionSuccess: (state) => {
      state.isRnsConnectionSuccess = true;
      state.isRnsConnectionClosed = false;
    },
    appUnloading: (state) => {
      state.isUnloading = true;
    },
    failedRnsConnection: (state) => {
      state.isRnsConnectionClosed = true;
      state.isRnsConnectionSuccess = false;
    },
    tokenSetOnHeaders: (state) => {
      state.isTokenSetOnHeaders = true;
    },
    tokenNotSetOnHeaders: (state) => {
      state.isTokenSetOnHeaders = false;
    },
    requestCognitoForcedLogout: (state) => {
      state.isCognitoForcedLogoutRequested = true;
    },
    clearCognitoForcedLogoutRequest: (state) => {
      state.isCognitoForcedLogoutRequested = false;
    },
    requestTeamingLogoutNoticeRedirect: (state) => {
      state.pendingVrsRedirect = {
        target: VrsRedirectTarget.TeamingLogoutNotice,
      };
    },
    requestInCenterTeamingNoticeRedirect: (
      state,
      action: PayloadAction<InCenterTeamingNoticeSnapshot>
    ) => {
      state.pendingVrsRedirect = {
        target: VrsRedirectTarget.InCenterTeamingNotice,
        snapshot: action.payload,
      };
    },
    clearPendingVrsRedirectTarget: (state) => {
      state.pendingVrsRedirect = null;
    },
  },
});

export const {
  setInnerLoading,
  rnsAttemptingToReconnect,
  rnsConnectionSuccess,
  appUnloading,
  failedRnsConnection,
  tokenSetOnHeaders,
  tokenNotSetOnHeaders,
  requestCognitoForcedLogout,
  clearCognitoForcedLogoutRequest,
  requestTeamingLogoutNoticeRedirect,
  requestInCenterTeamingNoticeRedirect,
  clearPendingVrsRedirectTarget,
} = appSlice.actions;

export default appSlice.reducer;
